<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>
            <v-card>
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout wrap>
                    <div class="flex md12">
                      <div v-show="codegorunum === true ">
                        <v-text-field label="Evrak Kodu" :color="color" v-model="Evrak.DocTypeCode" :error-messages="errors.collect('name')"
                          v-validate="'required|max:3'" data-vv-name="name" required></v-text-field>
                      </div>
                      <v-text-field label="Açıklama" :color="color" v-model="Evrak.DocTypeName" :error-messages="errors.collect('name2')"
                        v-validate="'required|max:100'" data-vv-name="name2" required>
                      </v-text-field>
                      <v-select :items="states1" :color="color" clearable="" v-model="select" :error-messages="errors.collect('select')"
                        v-validate="'required:true'" data-vv-name="select" label="Borç/Alacak"></v-select>
                      <v-select :items="states2" :color="color" clearable="" v-model="Evrak.AccountDC" label="Cari Tipi"></v-select>
                    </div>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="deleteevrak()">Sİl</v-btn>
            </div>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">VazgeÇ</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>Evrak</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
        <v-btn flat @click="evrakekle()"> Evrak Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.Evrakkod)" item>
            <td class="text-xs-left">{{ props.item.Evrakkod }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
            <td class="text-xs-left">{{ props.item.BA }}</td>
            <td class="text-xs-left">{{ props.item.Cari }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Evrak Kodu',
            value: 'Evrakkod'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          },
          {
            text: 'Borç/Alacak',
            value: 'BA'
          },
          {
            text: 'Cari Tipi',
            value: 'Cari'
          }
        ],
        items: [],
        color: 'orange darken-4',
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,
        name: '',
        name2: '',
        select: '',
        Evrak: {
          DocTypeCode: '',
          DocTypeName: '',
          DeptCredit: '',
          AccountDC: '',
          CompanyCode: '',
        },
        states1: [
          'Borç', 'Alacak'
        ],
        states2: [
          'Yok', '+', '-'
        ],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        dictionary: {
          custom: {
            name: {
              required: () => 'Bu alanı boş bırakılamaz',
              max: 'En fazla 3 karakterden oluşmalıdır.'
            },
            name2: {
              required: () => 'Bu alanı  boş bırakılamaz',
            },
            select: {
              required: () => 'lütfen seçiminizi yapınız',
            }
          }
        }
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Evrak Güncelle'


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          DocTypeCode: v
        }
        this.$http.post(auth.API_URL + 'api/doctype/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Evrak.DocTypeCode = response.body[0].Evrakkod
          this.Evrak.DocTypeName = response.body[0].Aciklama
          this.select = response.body[0].BA.trim()
          this.Evrak.AccountDC = response.body[0].Cari
        })
      },
      deleteevrak: deleteevrak,
      evrakekle: evrakekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
  }

  function Kaydet() {

    this.$validator.validateAll().then((result) => {

      if (result) {
        this.Evrak.DeptCredit = this.select

        if (this.Evrak.AccountDC === 'Yok') {
          this.Evrak.AccountDC = 'Y'
        }
        if (this.Evrak.DeptCredit === 'Alacak') {
          this.Evrak.DeptCredit = '1'
        } else {
          this.Evrak.DeptCredit = '0'
        }

        var params = this.Evrak
        this.$http.post(auth.API_URL + 'api/doctype/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/doctype/List', {}, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.dialog = false
                this.text1 = 'Service Unavailable'

              } else {
                this.dialog = false
                this.text1 = 'Service Unavailable'
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.dialog = false
            this.text1 = 'Service Unavailable'
          } else {
            this.dialog = false
            this.text1 = 'Service Unavailable'
          }
        })
      }
    })
  }

  function evrakekle() {
    this.dialog = true
    this.Evrak.DocTypeCode = ''
    this.Evrak.DocTypeName = ''
    this.Evrak.DeptCredit = null
    this.$validator.reset()
    this.dialog_baslik = 'Evrak Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode: credentials.SirketKodu,
    }

    this.progress = true
    this.$http.post(auth.API_URL + 'api/doctype/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.dialog = false
        this.text1 = response.body.ResponseMessage
        this.progress = false
      } else {
        this.dialog = false
        this.text1 = response.body.ResponseMessage
        this.progress = false
      }
    })
  }

  function deleteevrak() {
    if (window.confirm('Referans\'ı silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.Evrak.CompanyCode = credentials.SirketKodu



      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }

      var params = this.Evrak
      this.$http.post(auth.API_URL + 'api/doctype/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text1 = 'Silme işlemi tamamlandı'
            this.snackbar = true
          }, (response) => {
            if (response.status === 0) {
              this.dialog = false
              this.text1 = response.body.ResponseMessage
            } else {
              this.dialog = false
              this.text1 = response.body.ResponseMessage
            }
          })
        } else {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
        }
      }, (response) => {
        if (response.status === 0) {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
        } else {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {

      if (result) {
        this.Evrak.DeptCredit = this.select

        if (this.Evrak.AccountDC === 'Yok') {
          this.Evrak.AccountDC = 'Y'
        }
        if (this.Evrak.DeptCredit === 'Alacak') {
          this.Evrak.DeptCredit = '1'
        } else {
          this.Evrak.DeptCredit = '0'
        }

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        this.Evrak.CompanyCode = credentials.SirketKodu



        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }
        var params = this.Evrak
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/doctype/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>